import type Store from '@ember-data/store';
import type CompanyConfigurationModel from 'garaje/models/company-configuration';
import type StateService from 'garaje/services/state';

export default async function loadCompanyConfiguration(
  state: StateService,
  store: Store,
): Promise<CompanyConfigurationModel | undefined> {
  const companyConfigurationId = await state.fetchCompanyConfigId();
  if (!companyConfigurationId) return undefined;
  return await store.findRecord('company-configuration', companyConfigurationId);
}
